export const environment = {
PRODUCTION: true,
NAV_TYPE: 'prod',
CREW_APP_BACKEND_API_BASE_URL: 'https://api.stolt.com/css-member-app/v1',
CREW_APP_ENCRYPTION_KEY: 'BjF166KcTrdgeQw3/f+YlRpDNVFHUSnmvjqAwanMsXk=',
CREW_APP_ENCRYPTION_IV: 'w5bwYG6RNTdHr1O/Ms5kXA==',
CSS_SENTRY_DSN: 'https://244f8b573b4e18aa7638e27ce3331218@o4509530252574720.ingest.de.sentry.io/4509543512277072',
POSTHOG_API_KEY:'phc_XQEdP55O6sv8AFgS8aTBPTdLpMYL1wjyrCOQUuanMIv',
POSTHOG_API_HOST:'https://eu.i.posthog.com',
POSTHOG_API_DEFAULTS: '2025-07-07',
POSTHOG_ENABLED_TRACKING:true
};
